import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MaterialsList from './List';
import MaterialsCreate from './Create';
import EditMaterial from './Edit';

export default function DidacticCategories() {
  return (
    <Switch>
      <Route path="/app/didacticCategories/create/" exact component={MaterialsCreate} />
      <Route path="/app/didacticCategories/:didacticCategoryId/" component={EditMaterial} />
      <Route path="/app/didacticCategories/" component={MaterialsList} />
    </Switch>
  );
}
